const translations = {
  "en": {
    "Add Transaction": "Add Transaction",
    "Buy": "Buy",
    "Cancel": "Cancel",
    "Coin": "Symbol",
    "Confirm": "Confirm",
    "Date & Time": "Date & Time",
    "Edit Transaction": "Edit Transaction",
    "Fees": "Fees",
    "Price Per Symbol": "Price Per Unit",
    "Quantity": "Shares",
    "Sell": "Sell",
    "Total": "Total"
  },
  "zh-tw": {
    "Add Transaction": "新增交易紀錄",
    "Buy": "買入",
    "Cancel": "取消",
    "Coin": "資產代碼",
    "Confirm": "確認",
    "Date & Time": "交易時間",
    "Edit Transaction": "編輯交易紀錄",
    "Fees": "手續費",
    "Price Per Symbol": "單價",
    "Quantity": "股數",
    "Sell": "賣出",
    "Total": "總額"
  }
};

export default translations;
